import { render, staticRenderFns } from "./ProductReviewWrite.vue?vue&type=template&id=0a0e92d8&scoped=true"
import script from "./ProductReviewWrite.vue?vue&type=script&lang=js"
export * from "./ProductReviewWrite.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewWrite.vue?vue&type=style&index=0&id=0a0e92d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0e92d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VIcon,VRating,VTextarea})
